import { AutoCompleteOption, SelectOption } from '@shape-ds/components';
import { Equipment } from 'queries/conditionDeviation/contract';
import { Categories } from 'queries/sensors/types';
import * as types from 'types';

export function groupBy<IData>(
  collection: types.TData[],
  property: string,
  normalize = false,
): IData[] {
  let i = 0;
  let val;
  let index;
  const values: string[] = [];
  const result: unknown[] | types.TData = normalize ? {} : [];
  for (; i < collection.length; i += 1) {
    val = collection[i][property];
    index = values.indexOf(val);
    if (index > -1) {
      if (normalize) {
        (result as types.TData)[val].push(collection[i]);
      } else {
        (result as types.TData[])[index].push(collection[i]);
      }
    } else {
      values.push(val);
      if (normalize) {
        (result as types.TData)[val] = [collection[i]];
      } else {
        result.push([collection[i]]);
      }
    }
  }

  return result as IData[];
}

export function OptionsAutocompleteArrayMapper(options: Equipment[]): AutoCompleteOption[] {
  return options.map((item) => ({
    id: item.id,
    label: item.name,
  }));
}

export function SelectOptionsArrayMapper(options: string[]) {
  return options.map((item) => ({
    label: item.replaceAll('_', ' ').toLowerCase(),
    value: item,
    disabled: false,
  }));
}

export function SelectOptionsObjectArrayMapper(options: string[]): SelectOption[] {
  return options.map((item) => {
    const category = JSON.parse(item.replace(/'/g, '"'));
    return {
      value: category.id,
      label: category.name,
      disabled: false,
    };
  });
}

export function findCommonSensors(categories1: Categories, categories2: Categories): Categories {
  const commonCategories: Categories = {};

  for (const categoryName in categories1) {
    if (Object.prototype.hasOwnProperty.call(categories2, categoryName)) {
      commonCategories[categoryName] = categories1[categoryName].filter((sensor1) =>
        categories2[categoryName].some((sensor2) => sensor1.name === sensor2.name),
      );
    }
  }

  return commonCategories;
}
